import { BlackPopupRolagem } from "@/components/blog/BlackPopupRolagem";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { BlogHeader } from "@/components/blog/BlogHeader";
import { BlogFooter } from "@/components/blog/BlogFooter";
import { BlackDestaqueSection } from "@/components/black2x1/BlackDestaqueSection";
import "@/styles/efisio.css";

export const Route = createFileRoute("/e-fisio")({
  component: BlogLayout,
});

function BlogLayout() {
  return (
    <div className="efisio-scope min-h-screen">
      <BlogHeader />
      <Outlet />
      <BlackDestaqueSection origem="e-fisio" />
      <BlackPopupRolagem origem="efisio" />
      <BlogFooter />
    </div>
  );
}
